<template>
  <div class="max-w-[292px]">
    <ImageSvg :name="imageName" />
  </div>
  <p>Share your item to get views.</p>
  <div class="flex gap-2">
    <Button type="solid" variant="blue" icon="general.copy" data-testid="viewer-analytics-share-copy" @click.prevent="copyAction('analytics_share')"
      >Copy link</Button
    >
    <Button type="link" variant="black" :icon="getSharingIcon()" data-testid="viewer-analytics-share-modal" @click.prevent="openShareModalAction">Share</Button>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Button, ImageSvg } from '@/storybook';
import { useItemActions } from '@/modules/viewer/composables/useItemActions';
import { useItemShare } from '@/modules/viewer/composables/useItemShare';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const { publicVisitsCount } = storeToRefs(useViewerItemStore());

const { openShareModalAction, copyAction } = useItemActions();
const { getSharingIcon } = useItemShare();

const imageName = computed(() => {
  return publicVisitsCount.value ? 'analytics.emptyCalendar' : 'analytics.emptyEye';
});
</script>
